import { ResponsabiliteDocument } from './document-pa-traduction-update-order.entity';

export class TraductionPaEntity {
	
	id!: number;
	parent!: TraductionPaEntity[] | null;
	type!: string;
	fr!: string;
	en!: string | null;
	es!: string | null;
	ordre!: number;
	categorie!: string;
	imagePath!: string | null;
	imagePosition!: 'left' | 'right' | 'center' | null;
	imageSize!: 'sm' | 'md' | 'lg' | null;
	customFields!: any;
	presentation!: string;
	enfants!: TraductionPaEntity[] | null;

	checked!: boolean;
	responsibility!: ResponsabiliteDocument | null;
	
	activites: TraductionPaEntity[] = [];
	riskOrImpacts: TraductionPaEntity[] = [];
	mesures: TraductionPaEntity[] = [];
	texteLibre?: string;
	infoGroupement!: number;
	isGroupEnd?: boolean;
	groupes?: any[];
	autreId?: number | null;
}